<div [matTooltip]="cellValue">
    {{cellValue.substring(0, 100)}} {{cellValue.length > 100 ? '...'  : ''}}
</div>